import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../../api/compliance";
import Snackbar, { TTypeMessage } from "../../../../../components/ui/Snackbar";

interface IProps {
  ids: number[];
}
const DeleteNote: React.FC<IProps> = ({ ids }) => {
  const queryClient = useQueryClient();

  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [onDeleteStatus, setOnDeleteStatus] = useState<TTypeMessage>("");
  const [isOpenSnackbar, setOpenSnackbar] = useState(false);

  const handleCloseSnackBar = () => setOpenSnackbar(false);

  const mutation = useMutation({
    mutationFn: async () => {
      const query = new URLSearchParams();
      query.append("ids", ids.join(","));
      setIsLoading(true);
      await ComplianceAPI.deleteWatchlistNote(query.toString());
    },
    onSuccess: async () => {
      setIsOpen(false);
      setIsLoading(false);
      setOpenSnackbar(true);
      setOnDeleteStatus("success");
      await queryClient.invalidateQueries({ queryKey: [COMPLIANCE_API_URLS.getSearchNotes] });
    },
    onError: () => {
      setIsLoading(false);
      setOpenSnackbar(true);
      setOnDeleteStatus("error");
    },
  });

  return (
    <div>
      <Dialog open={isOpen} fullWidth>
        <DialogTitle>Delete note</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete note?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button onClick={() => mutation.mutate()} color="secondary" disabled={isLoading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        type={onDeleteStatus}
        isOpenSnackbar={isOpenSnackbar}
        responseSuccessMessage="Watchlist note deleted successfully."
        responseErrorMessage={"Error: Unable to delete watchlist note."}
        onClose={handleCloseSnackBar}
      />

      <IconButton onClick={() => setIsOpen(true)} size="small">
        <DeleteForeverIcon color="secondary" cursor="pointer" />
      </IconButton>
    </div>
  );
};

export default DeleteNote;
